export default __webpack_public_path__ + "static/media/assistant.dc1c0310.svg";